module.exports = __webpack_public_path__ + "static/media/pa.8416cf88.svg";